export const DUPLICATE_USER_SEGMENT_REQUEST = "DUPLICATE_USER_SEGMENT_REQUEST";
export const DUPLICATE_USER_SEGMENT_SUCCESS = "DUPLICATE_USER_SEGMENT_SUCCESS";
export const DUPLICATE_USER_SEGMENT_FAILURE = "DUPLICATE_USER_SEGMENT_FAILURE";

export const DELETE_USER_SEGMENT_REQUEST = "DELETE_USER_SEGMENT_REQUEST";
export const DELETE_USER_SEGMENT_SUCCESS = "DELETE_USER_SEGMENT_SUCCESS";
export const DELETE_USER_SEGMENT_FAILURE = "DELETE_USER_SEGMENT_FAILURE";

export const SAVE_USER_SEGMENT_REQUEST = "SAVE_USER_SEGMENT_REQUEST";
export const SAVE_USER_SEGMENT_SUCCESS = "SAVE_USER_SEGMENT_SUCCESS";
export const SAVE_USER_SEGMENT_FAILURE = "SAVE_USER_SEGMENT_FAILURE";

export const CREATE_USER_SEGMENT_REQUEST = "CREATE_USER_SEGMENT_REQUEST";
export const CREATE_USER_SEGMENT_SUCCESS = "CREATE_USER_SEGMENT_SUCCESS";
export const CREATE_USER_SEGMENT_FAILURE = "CREATE_USER_SEGMENT_FAILURE";

export const FETCH_USER_SEGMENT_REQUEST = "FETCH_USER_SEGMENT_REQUEST";
export const FETCH_USER_SEGMENT_SUCCESS = "FETCH_USER_SEGMENT_SUCCESS";
export const FETCH_USER_SEGMENT_FAILURE = "FETCH_USER_SEGMENT_FAILURE";

export const FETCH_USER_SEGMENT_ORGANIZATIONS_REQUEST =
  "FETCH_USER_SEGMENT_ORGANIZATIONS_REQUEST";
export const FETCH_USER_SEGMENT_ORGANIZATIONS_SUCCESS =
  "FETCH_USER_SEGMENT_ORGANIZATIONS_SUCCESS";
export const FETCH_USER_SEGMENT_ORGANIZATIONS_FAILURE =
  "FETCH_USER_SEGMENT_ORGANIZATIONS_FAILURE";

export const FETCH_USER_SEGMENT_GROUPS_REQUEST =
  "FETCH_USER_SEGMENT_GROUPS_REQUEST";
export const FETCH_USER_SEGMENT_GROUPS_SUCCESS =
  "FETCH_USER_SEGMENT_GROUPS_SUCCESS";
export const FETCH_USER_SEGMENT_GROUPS_FAILURE =
  "FETCH_USER_SEGMENT_GROUPS_FAILURE";

export const FETCH_USER_SEGMENT_USERS_REQUEST =
  "FETCH_USER_SEGMENT_USERS_REQUEST";
export const FETCH_USER_SEGMENT_USERS_SUCCESS =
  "FETCH_USER_SEGMENT_USERS_SUCCESS";
export const FETCH_USER_SEGMENT_USERS_FAILURE =
  "FETCH_USER_SEGMENT_USERS_FAILURE";

export const FETCH_USERS_REQUEST = "FETCH_USERS_REQUEST";
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const FETCH_USERS_FAILURE = "FETCH_USERS_FAILURE";

export const CHANGE_NAME = "CHANGE_NAME";
export const CHANGE_USER_TYPE = "CHANGE_USER_TYPE";

export const CHANGE_TAG = "CHANGE_TAG";
export const ADD_TAG = "ADD_TAG";
export const REMOVE_TAG = "REMOVE_TAG";

export const CHANGE_ORGANIZATION = "CHANGE_ORGANIZATION";
export const ADD_ORGANIZATION = "ADD_ORGANIZATION";
export const REMOVE_ORGANIZATION = "REMOVE_ORGANIZATION";

export const CHANGE_GROUP = "CHANGE_GROUP";
export const ADD_GROUP = "ADD_GROUP";
export const REMOVE_GROUP = "REMOVE_GROUP";

export const RESET_USER_SEGMENT = "RESET_USER_SEGMENT";
export const RESET_USER_SEGMENT_ATTRIBUTES = "RESET_USER_SEGMENT_ATTRIBUTES";



// WEBPACK FOOTER //
// ./src/actions/userSegment/types.js